module.exports = __webpack_public_path__ + "static/media/create-campaign-completed@2x.1ec4d115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/create-campaign-completed@2x.png
// module id = 356
// module chunks = 1